<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-coming-of-the-train-1">
<h1>The Coming of the Train</h1>
<p style="text-indent:0em">One day an old and worn-out train</p>
<p style="text-indent:0em">will come along and call my name,</p>
<p style="text-indent:0em">and I will know to climb inside.</p><br/>
<p style="text-indent:0em">There’ll be no reason for me to run.</p>
<p style="text-indent:0em">I’ll have no shadow in the sun</p>
<p style="text-indent:0em">and know there is no need to hide.</p><br/>
<p style="text-indent:0em">And then the man I tried to be</p>
<p style="text-indent:0em">will look out the glass and see</p>
<p style="text-indent:0em">fields of dreams and azure skies.</p><br/>
<p style="text-indent:0em">And I will have no fears or tears</p>
<p style="text-indent:0em">and will not pray for one more day.</p><br/>
<p style="text-indent:0em">The train runs swiftly on silent tracks</p>
<p style="text-indent:0em">and my yesterdays will be flash backs,</p>
<p style="text-indent:0em">thousands in the blink of an eye.</p><br/>
<p style="text-indent:0em">Wave to me, and do not cry</p>
<p style="text-indent:0em">as the whistle blows and I pass by</p>
<p style="text-indent:0em">on one last ride to see the sea.</p><br/>
<p style="text-indent:0em">And then the man I tried to be</p>
<p style="text-indent:0em">will look out across that sea,</p>
<p style="text-indent:0em">and see horizons of goodbye.</p><br/>
<p style="text-indent:0em">And I will have no fears or tears</p>
<p style="text-indent:0em">and will not pray for one more day.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?0252655a